import { createContext, useContext } from 'react';

export type ActionBreadcrumb = (
  message: string,
  level?: 'info' | 'error',
  data?: Record<string, unknown>,
) => void;

const noBreadcrumb: ActionBreadcrumb = () => undefined;

export const ActionBreadcrumbContext = createContext<ActionBreadcrumb>(noBreadcrumb);

export function useActionBreadcrumb(): ActionBreadcrumb {
  return useContext(ActionBreadcrumbContext);
}
